import React, { useState } from "react";
import {
	RadioGroup,
	FormHelperText,
} from "@mui/material";
import { BpCheckedIcon, BpIcon, FormContainer, FormControlLabelText, FormLabelContainer, RadioContainer } from "./Styled";
import { ImagePath } from "../../../../../assets/ImagePath";
import CachedImage from '../../../../../components/common/CachedImage';


function BpRadio(props) {
	return (
	
		<RadioContainer
			disableRipple
			color="default"
			checkedIcon={<BpCheckedIcon />}
			icon={<BpIcon />}
			{...props}
		/>

	);
}

const RadioInput = (props) => {
	const {
		id,
		info,
		readOnly,
		value,
		handleChange,
		onBlurField,
		mandatory,
		options,
		title,
		validation,
		validationResult,
		validationMessage,
	} = props;
	const [error, setError] = useState(false);

	const handleSingleRadioClick = (e) => {
		if (mandatory) {
		} else {
			if (e.target.value === value) {
				handleChange(e, "uncheckRadioButton");
				onBlurField(e);
			} else {
				handleChange(e, "checkRadioButton");
				onBlurField(e);
			}
		}
	};

	const handleCheck = (e) => {
		if (mandatory) {
			handleChange(e);
			onBlurField(e);
		} else {
		}
	};
	const isBoolean = (val) => "boolean" === typeof val;

	return (
		<FormContainer
			required={mandatory}
			error={validation && isBoolean(validationResult) ? !validationResult : false}
		>
			<div className="relative flex items-start gap-1 update-input">
						<span className="min-w-[17px] h-[17px] rounded-7 flex items-center">
							<CachedImage
								image={ImagePath.radioBtnIcon}
								imgKey="radio-Btn-Icon"
								className="w-[17px] h-[17px]"
							/>
							
						</span>
						<div className="w-full">
					
			{/*{(isSmallScreen || isSections === true) && (*/}
			<FormLabelContainer component="legend">{title}</FormLabelContainer>
			
			{/*)}*/}
			<RadioGroup
				id={id}
				name={id}
				value={value || ""}
				error={error}
				onChange={handleCheck}
			>
				{options?.map((item) => (
					<FormControlLabelText className="under-text-size"
						key={item}
						disabled={readOnly}
						value={item}
						sx={{ color: "black" }}
						control={<BpRadio onClick={handleSingleRadioClick} />}
						label={item?.charAt(0).toUpperCase() + item?.slice(1)}
					/>
				))}
			</RadioGroup>
			{!props.inline && (
				<FormHelperText>
					{isBoolean(validationResult) && !validationResult
						? validationMessage
						: info}
				</FormHelperText>
			)}
			</div>
			</div>
		</FormContainer>
	);
};
export default RadioInput;
